import { Button } from '@pesto/ui/components/Button';
import { Sheet, SheetContent } from '@pesto/ui/components/Sheet';
import { ExternalLink } from 'lucide-react';

import type { StatementListItem } from '../types/Statements.types';

import { StatementDetailsCard } from './StatementDetailsCard';

interface StatementQuickViewProps {
  statement: StatementListItem | null;
  onClose: () => void;
  onViewFullDetails?: (statementId: string) => void;
  getLoanHref?: (loanId: string) => string;
}

export const StatementQuickView = ({ statement, onClose, onViewFullDetails, getLoanHref }: StatementQuickViewProps) => {
  return (
    <Sheet open={!!statement} onOpenChange={(open) => !open && onClose()}>
      <SheetContent
        side="right"
        className="sm:max-w-2xl"
        title="Statement Details"
        description="Quick view of statement"
      >
        {statement && (
          <div className="flex flex-col gap-4">
            {onViewFullDetails && (
              <div className="flex justify-end">
                <Button variant="outline" size="sm" onClick={() => onViewFullDetails(statement.id)}>
                  <ExternalLink className="mr-2 h-4 w-4" />
                  View Full Details
                </Button>
              </div>
            )}
            <StatementDetailsCard statement={statement} getLoanHref={getLoanHref} />
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
};
